<template>
	<section class="modal j-popup j-omya-popup-2">
		<div class="modal__card" style="width:610px;">
			<div class="modal__image-holder">
				<img src="../../../static/images/maraphones/omya_2.png" width="100%" alt="" %>
			</div>
			<div class="modal__main">
				<p class="modal__text modal__text--large bold-font">Уважаемые коллеги!</p>
				<p class="modal__text">
					Стартовала первая неделя нашего марафона. Любознательный космонавт передал нам несколько
					зашифрованных сигналов о&nbsp;своих координатах:
				</p>
				<p class="modal__text">
					1)&nbsp;&nbsp;<span style="letter-spacing: 2px;">--... -.... ..... ----.</span><br>
					2)&nbsp;&nbsp;<span style="letter-spacing: 2px;">--... -.... ..... --...</span><br>
					3)&nbsp;&nbsp;<span style="letter-spacing: 2px;">--... -.... -.... -----</span><br>
					4)&nbsp;&nbsp;<span style="letter-spacing: 2px;">--... -.... ..... -....</span>
				</p>

				<p class="modal__text">
					Удастся&nbsp;ли нам найти его в&nbsp;этих уголках галактики Эдюсон? Давайте узнаем вместе!
					Для этого расшифруйте шифр и&nbsp;пройдите 4&nbsp;загаданных курса.
				</p>
				<p class="modal__text">
					Перед стартом не&nbsp;забудьте ознакомиться
					с&nbsp;<a
						href="https://downloads.eduson.tv/materials/files/000/010/965/original/Регламент_марафона_Omya_(29.06.26).pdf"
						class="link-btn link-btn--underline bold-font"
						style="color: #58298b;"
						target="_blank"
						rel="noopener noreferrer"
					>
						правилами марафона.
					</a>
					Данный этап продлится
					по&nbsp;5&nbsp;июля включительно. <br>Желаем успехов в&nbsp;обучении!
				</p>
			</div>
			<div class="text-center" style="background-color: #1a1734;border-radius: 0 0 5px 5px;padding: 40px;">
				<button
					class="regular-btn red-white-btn bold-font j-upd-additional-info j-hide-popup"
					:data-url="upd_additional_info_path"
					data-additional-info="omya_06_26"
					type="button"
				>Приступить</button>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'OmyaPopup2',

	props: {
		upd_additional_info_path: ''
	},

	data() {
		return {
			isShow: false
		}
	},

	methods: {
		closePopup() {
		},
	},
}
</script>

